import IconOverflowSolid from '@apollo/icons/default/IconOverflowSolid.svg';
import {
  IconButton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@apollo/orbit';
// TODO: Remove use of `Box` and `Icon`
// eslint-disable-next-line no-restricted-imports
import { Box, Icon } from '@chakra-ui/react';
import classnames from 'classnames';
import React from 'react';

export const DomainStatusTable = () => {
  // Example data array
  const data = [
    { domain: 'main--graphref.apollographos.net', status: 'Connected' },
    { domain: 'api.mydomain.com', status: 'Disconnected' },
  ];

  return (
    <>
      <TableContainer>
        <Table variant="striped">
          <Thead>
            <Tr>
              <Th>Domain</Th>
              <Th>Status</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.map(({ domain, status }) => (
              <Tr key={domain}>
                <Td>
                  <div className="flex items-center justify-between">
                    {domain}
                    <IconButton
                      onClick={() => {}}
                      aria-label="Edit domain"
                      variant="hidden"
                      icon={<Icon className="size-4" as={IconOverflowSolid} />}
                    />
                  </div>
                </Td>
                <Td>
                  <Box
                    as="span"
                    role="status"
                    className={classnames(
                      'mr-2 inline-block size-2 rounded-md',
                      status === 'Connected'
                        ? 'bg-icon-success'
                        : 'bg-icon-error',
                    )}
                  />
                  {status}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
